import classNames from "classnames";
import {EmblaViewportRefType} from "embla-carousel-react";
import {ProductMediaSources} from "../../model/types";
import {ProductMarkers} from "../ProductMarkers/ProductMarkers";
import {Video} from "@/shared/ui/Video";
import {Picture} from "@/shared/ui/Picture";
import styles from "./ProductCarousel.module.scss";

type Props = {
    carouselRef: EmblaViewportRefType;
    media: ProductMediaSources[];
    alt: string;
    onZoom?: (index: number) => void;
    className?: string;
    activeSlide?: boolean;
    sticker?: string | null;
}

export const ProductCarousel = (
    {carouselRef, media, alt, onZoom = undefined, className, activeSlide, sticker}: Props
) => {
    const onClick = (index) => {
        if (onZoom) {
            onZoom(index);
        }
    }

    return (
        <div className={className}>
            <ProductMarkers sticker={sticker} className={styles.marker} />
            <div ref={carouselRef} className={styles.viewport}>
                <div className={styles.container}>
                    {media.map((item, index) => {
                        return (
                            <div
                                key={item.src}
                                className={classNames(styles.slide, {[styles.active]: activeSlide, [styles.zoom]: onZoom})}
                                onClick={() => onClick(index)}
                            >
                                <div className={classNames(styles.inner, {[styles.active]: activeSlide})}>
                                    {item.type === 'video' && (
                                        <Video
                                            sources={[item.src]}
                                            preload={`metadata`}
                                            uiControls={false}
                                            autoPlay
                                            loop
                                        />
                                    )}
                                    {item.type === 'image' && (
                                        <Picture src={item.src} alt={alt} />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
